// extracted by mini-css-extract-plugin
export default {"shop_product__list":"ProductList_shop_product__list__g45Qi","product-list":"ProductList_product-list__Da0V4","search-box":"ProductList_search-box__r4bxI"};